var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "list" },
    [
      _c(
        "draggable",
        {
          staticClass: "drag-container",
          attrs: {
            tag: "div",
            "ghost-class": "sortable__ghost",
            group: "list",
            list: _vm.value,
            "force-fallback": true,
            move: _vm.onGroupMove,
          },
          on: { change: _vm.resortGroups },
        },
        _vm._l(_vm.value, function (group) {
          return _c(
            "div",
            {
              key: group.id,
              staticClass: "list-group",
              attrs: { "data-fake": !group.id },
            },
            [
              !group.id
                ? [
                    _c(
                      "div",
                      { staticClass: "list-items" },
                      [
                        _c(
                          "draggable",
                          {
                            staticClass: "drag-container",
                            attrs: {
                              "ghost-class": "sortable__ghost",
                              group: "item",
                              list: group.items,
                              "force-fallback": true,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.resortGroup($event, group)
                              },
                            },
                          },
                          _vm._l(group.items, function (item) {
                            return _c(
                              "div",
                              { key: item.id, staticClass: "list-item" },
                              [_vm._t("item", null, { item: item })],
                              2
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                  ]
                : [
                    _c(
                      "div",
                      { staticClass: "list-group__header" },
                      [_vm._t("group", null, { group: group })],
                      2
                    ),
                    _c(
                      "slide-up-down",
                      {
                        staticClass: "list-group__items",
                        attrs: {
                          active: group.open || group.empty,
                          duration: 400,
                        },
                      },
                      [
                        group.loading
                          ? _c("loader", {
                              staticClass: "list-group__loader",
                              attrs: { active: group.loading, height: "38" },
                            })
                          : _c(
                              "div",
                              { staticClass: "list-items" },
                              [
                                _c(
                                  "draggable",
                                  {
                                    staticClass: "drag-container",
                                    attrs: {
                                      "ghost-class": "sortable__ghost",
                                      group: "item",
                                      "data-group": group.id,
                                      list: group.items,
                                      "force-fallback": true,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.resortGroup($event, group)
                                      },
                                    },
                                  },
                                  _vm._l(group.items, function (item) {
                                    return _c(
                                      "div",
                                      {
                                        key: item.id,
                                        staticClass: "list-item",
                                      },
                                      [
                                        _vm._t("item", null, {
                                          item: item,
                                          group: group,
                                        }),
                                      ],
                                      2
                                    )
                                  }),
                                  0
                                ),
                              ],
                              1
                            ),
                      ],
                      1
                    ),
                  ],
            ],
            2
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }